import { WebinarSession } from "../types/models";
import { copyToClipboard } from "./copyToClipboard";

export function formatSessionDetails(session: WebinarSession): string {
  const takes = session.takeaways.map((t) => `• ${t}`).join("\n");
  return [
    session.title,
    session.oneLiner,
    "",
    `Topic: ${session.topicName}`,
    `Host: ${session.hostName} (${session.hostRole})`,
    `When: ${session.date} ${session.time} ${session.timezone} (${session.mins} min)`,
    `Access: ${session.access}`,
    `Provider: ${session.provider}`,
    `Join: ${session.joinUrl}`,
    "",
    "Description:",
    session.fullDesc,
    "",
    "Takeaways:",
    takes,
  ].join("\n");
}

export async function copySessionDetails(
  session: WebinarSession
): Promise<boolean> {
  return copyToClipboard(formatSessionDetails(session));
}
